<canvas ref="barChart"></canvas>

  
<script>
    import { Bar } from 'vue-chartjs'
  
    export default {
        name: 'TrafficBarChart',
        extends: Bar,
        props: {
            labels: { type: Array, default: () => [] },
            datasets: { type: Array, default: () => [] }
        },
        mounted() {
            this.drawChart()
        },
        watch: {
            labels: 'drawChart',
            datasets: {
                handler: 'drawChart'
            }
        },
        methods:{
            drawChart(){
                this.renderChart({
                    labels: this.labels,
                    datasets: this.datasets
                }, {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: { display: false }
                })
            }
        }
    }
</script>
  
<style scoped>
  div, canvas {
    min-height: 280px;
  }
</style>